// Reproduces the scheme every admin/employee residual-risk-score column used to
// hardcode inline (score<3 green, 3-11 yellow, >=12 red), now driven by the
// tenant's config.RiskLevels so a tenant can move the low/high boundaries.
export const DEFAULT_RISK_LEVELS = { low: 2, high: 12 };

export function getRiskBand(score, riskLevels) {
  const { low, high } = { ...DEFAULT_RISK_LEVELS, ...riskLevels };
  if (score <= 0) return "high";
  if (score <= low) return "low";
  if (score < high) return "medium";
  return "high";
}

export function getRiskScoreColorClass(score, riskLevels) {
  const band = getRiskBand(score, riskLevels);
  return band === "low" ? "text-riskGreen" : band === "medium" ? "text-riskYellow" : "text-riskRed";
}
